/* tslint:disable */
/* eslint-disable */
/**
 * Vayu API
 * The Vayu API is a RESTful API that allows you to submit events for processing and storage & manage billing related entities.           The API is secured using the Bearer Authentication scheme with JWT tokens.           To obtain a JWT token, please contact Vayu at team@withvayu.com
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@withvayu.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    CreditProductSettings,
    instanceOfCreditProductSettings,
    CreditProductSettingsFromJSON,
    CreditProductSettingsFromJSONTyped,
    CreditProductSettingsToJSON,
} from './CreditProductSettings';
import {
    ServiceProductSettings,
    instanceOfServiceProductSettings,
    ServiceProductSettingsFromJSON,
    ServiceProductSettingsFromJSONTyped,
    ServiceProductSettingsToJSON,
} from './ServiceProductSettings';

/**
 * @type ProductSettings
 * 
 * @export
 */
export type ProductSettings = { productType: 'Credit' } & CreditProductSettings | { productType: 'Service' } & ServiceProductSettings;

export function ProductSettingsFromJSON(json: any): ProductSettings {
    return ProductSettingsFromJSONTyped(json, false);
}

export function ProductSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['productType']) {
        case 'Credit':
            return {...CreditProductSettingsFromJSONTyped(json, true), productType: 'Credit'};
        case 'Service':
            return {...ServiceProductSettingsFromJSONTyped(json, true), productType: 'Service'};
        default:
            throw new Error(`No variant of ProductSettings exists with 'productType=${json['productType']}'`);
    }
}

export function ProductSettingsToJSON(value?: ProductSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['productType']) {
        case 'Credit':
            return CreditProductSettingsToJSON(value);
        case 'Service':
            return ServiceProductSettingsToJSON(value);
        default:
            throw new Error(`No variant of ProductSettings exists with 'productType=${value['productType']}'`);
    }

}

